;(function () {
  'use strict';

  if (!customElements.get('customer-photos-videos-component')) {
    class CustomerPhotosVideosComponent extends HTMLElement {
      constructor() {
        super();
        this.slider = this.querySelector('.swiper.customer-photos-videos__slider');
        this.slides = Array.from(this.querySelectorAll('.swiper-slide'));
        this.swiper = null;
        this.prevButton = this.querySelector('.customer-photos-videos__button-prev');
        this.nextButton = this.querySelector('.customer-photos-videos__button-next');
      }

      connectedCallback() {
        if (this.slider && this.slides.length > 0) {
          this.initSwiper();
          window.addEventListener('resize', () => this.handleResize());
        }
      }

      disconnectedCallback() {
        if (this.swiper) {
          this.swiper.destroy(true, true);
        }
        window.removeEventListener('resize', () => this.handleResize());
      }

      handleResize() {
        if (this.swiper) {
          this.swiper.update();
        }
      }

      initSwiper() {
        if (!this.slider) return;

        const slidesPerView = parseFloat(this.dataset.slidesPerView) || 4;
        const spaceBetween = parseInt(this.dataset.spaceBetween) || 20;
        const slidesCount = this.slides.length;

        // Calculate actual slides per view (don't exceed available slides)
        const actualSlidesPerView = Math.min(slidesPerView, slidesCount);

        this.swiper = new Swiper(this.slider, {
          slidesPerView: 1.2,
          spaceBetween: 15,
          loop: slidesCount > actualSlidesPerView,
          speed: 400,
          navigation: {
            nextEl: this.nextButton,
            prevEl: this.prevButton,
          },
          breakpoints: {
            750: {
              slidesPerView: Math.min(2.5, slidesCount),
              spaceBetween: spaceBetween,
            },
            1200: {
              slidesPerView: actualSlidesPerView,
              spaceBetween: spaceBetween,
            },
          },
        });

        // Update navigation button states
        if (this.swiper && slidesCount <= actualSlidesPerView) {
          if (this.prevButton) this.prevButton.style.opacity = '0.5';
          if (this.nextButton) this.nextButton.style.opacity = '0.5';
        }
      }

    }

    customElements.define('customer-photos-videos-component', CustomerPhotosVideosComponent);
  }
})();

